module.exports = __webpack_public_path__ + "static/media/mode-44.2cdc8219.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Containers/Workspace/Tools/GgbIcons/mode-44.svg
// module id = 998
// module chunks = 2